import { Spinner } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'

import { EditTriviaListDetails } from './edit-trivia-list-details'
import { SYSTEM_TRIVIA_LIST_IMAGES_FOLDER } from './edit-trivia-list-route-admin'
import { useQuerySystemTriviaList } from '../queries/useQuerySystemTriviaList'
import { useUpdateSystemTriviaList } from '../queries/useUpdateSystemTriviaList'

interface RouteParams {
  listId: string
}

export const EditTriviaListDetailsRouteAdmin = observer(() => {
  const { listId } = useParams<RouteParams>()
  const { data, isLoading, isSuccess } = useQuerySystemTriviaList(listId)

  const { isLoading: isSaving, mutate: updateSystemTriviaList } = useUpdateSystemTriviaList({
    listId
  })

  if (isLoading) return <Spinner />

  if (!isSuccess) return null

  return (
    <EditTriviaListDetails
      baseUrl='/admin/'
      imageStorageFolder={SYSTEM_TRIVIA_LIST_IMAGES_FOLDER}
      initialValues={data}
      isSaving={isSaving}
      updateTriviaList={updateSystemTriviaList}
    />
  )
})
